import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CustomFiltersService } from '@team/services/common/custom-filters.service';
import { filter, map } from 'rxjs/operators';
@Component({
  selector: 'providers-dashboard',
  standalone: false,
  templateUrl: './providers-dashboard.component.html',
  styleUrls: ['./providers-dashboard.component.scss']

})
export class ProvidersDashboardComponent implements OnInit {
  showMenu = false;
  menuLinks = [];
  collapseMenuFlagData;
  collapseMenu: boolean;
  fullWidth: boolean = false;
  displayMenuButton: boolean = false;
  constructor(
    private router: Router,
    private common: CustomFiltersService,
    private activatedRoute: ActivatedRoute
  ) {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map(route => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .subscribe((route: any) => {
        route.params.subscribe((params: any) => {
          if (params?.requestId) {
            this.fullWidth = true;
            this.displayMenuButton = true;
          } else {
            this.fullWidth = false;
            this.displayMenuButton = false;
          }
        });
      });
  }

  ngOnInit(): void {
    this.menuLinks = [
      {
        title: 'الطلبات',
        icon: 'banking-bill-overdue'
      }
    ];
    if (localStorage.getItem('collapsed') === null) {
      this.collapseMenu = true;
    } else {
      // found + true or false
      this.collapseMenu = JSON.parse(localStorage.getItem('collapsed'));
      this.common.collapseMenu(this.collapseMenu);
    }
    this.common.currentflag.subscribe((res: any) => {
      this.collapseMenuFlagData = res;
    });
  }
  toggleMenuResponsive() {
    this.showMenu = !this.showMenu;
  }
  toggleMenuDesktop() {
    this.collapseMenu = !this.collapseMenu;
    this.common.collapseMenu(this.collapseMenu);
    localStorage.setItem('collapsed', JSON.stringify(this.collapseMenu));
  }
}